import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-device-permission-dialog',
  template: `
    <div class="standard-dialog">
      <div class="header" mat-dialog-title>
        <div class="title-section">
          <h2>{{ 'DevicePermissionDialog.Title' | translate }}</h2>
          <p class="subtitle">{{ 'DevicePermissionDialog.Subtitle' | translate }}</p>
        </div>
        <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="form-content">
        <div class="mb-3">
          <p class="mb-3 leading-relaxed text-sm">{{ 'DevicePermissionDialog.Message1' | translate }}</p>

          <div class="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-4 items-stretch">
            <!-- Left Column: Steps -->
            <div class="bg-[#f9f9f9] p-4 rounded-lg border border-(--skz-border-color-main,#e5e7eb) flex flex-col justify-center">
              <h4 class="mt-0 mb-2 font-semibold text-sm">{{ 'DevicePermissionDialog.StepsTitle' | translate }}</h4>
              <ul class="list-disc pl-5 space-y-1.5 leading-relaxed text-sm">
                <li>{{ 'DevicePermissionDialog.Step1' | translate }}</li>
                <li>{{ 'DevicePermissionDialog.Step2' | translate }}</li>
                <li>{{ 'DevicePermissionDialog.Step3' | translate }}</li>
                <li>{{ 'DevicePermissionDialog.Step4' | translate }}</li>
              </ul>
            </div>

            <!-- Right Column: Visual Guide (Video) -->
            <div class="flex items-center justify-center border border-(--skz-border-color-main,#e5e7eb) rounded-lg overflow-hidden bg-gray-50 min-h-[320px]">
              <video
                src="https://firebasestorage.googleapis.com/v0/b/skillztank-1573503855694.appspot.com/o/demos%2Fenable-camera-and-mic.mp4?alt=media&token=752212c7-e886-4dc2-a597-0c71f02324ff"
                autoplay
                loop
                muted
                playsinline
                class="object-contain max-h-[320px] w-full"
              ></video>
            </div>
          </div>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="footer">
        <div class="right-actions">
          <button mat-flat-button color="primary" (click)="dialogRef.close()">{{ 'DevicePermissionDialog.GotIt' | translate }}</button>
        </div>
      </mat-dialog-actions>
    </div>
  `,
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevicePermissionDialogComponent {
  dialogRef = inject(MatDialogRef<DevicePermissionDialogComponent>);
}
